export { AuthorizationFooter } from './AuthorizationFooter';
